import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useObservable } from '../hooks/rxjs';
import { FullscreenPortal } from '../components/fullscreen_portal';
import { CallNotification } from '../components/incoming_calls/call_notification';
import { UserSessionProvider } from '../context/user_session';
import { logger } from '../util/logger';
import { streem } from 'streem-sdk-protobuf';
import { APIError } from '@streem/api';
export const CallNotificationListener = ({ userSession, callConfig, autoAcceptInvites, SystemNotificationComponent, handleAnswerCallError, handleAnswerCallCanceled, onAnswerCallback, }) => {
    const [pendingInvitation] = useObservable(userSession.currentPendingInvitation);
    const [availabilityStatus] = useObservable(userSession.currentAvailabilityStatus);
    const answerCall = async () => {
        if (pendingInvitation) {
            try {
                // we handle the callback before we accept the invitation to prevent loss of context
                await onAnswerCallback?.();
                await userSession.acceptInvitation(pendingInvitation, callConfig);
            }
            catch (error) {
                if (error instanceof Error && error.cause instanceof APIError) {
                    if (error.cause.status === 400) {
                        logger.warn(`Could not accept invitation in PENDING state: ${error.cause}`);
                        handleAnswerCallCanceled?.();
                    }
                }
                else {
                    logger.error(`Error accepting invitation: ${error}`);
                    handleAnswerCallError?.();
                }
            }
        }
    };
    const rejectCall = async () => {
        if (pendingInvitation) {
            await userSession.rejectInvitation(pendingInvitation);
        }
    };
    // This useEffect is meant to replicate componentDidMount
    useEffect(() => {
        logger.info(`CallNotificationListener component initialized. ${pendingInvitation ? `pendingInvitationId=${pendingInvitation.id}` : ''}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (pendingInvitation?.status === 'PENDING' && autoAcceptInvites) {
            answerCall();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoAcceptInvites, pendingInvitation]);
    const availabilityStatusNotAvailable = availabilityStatus?.availabilityStatus ===
        streem.api.AvailabilityStatus.AVAILABILITY_STATUS_NOT_AVAILABLE;
    return (_jsx(FullscreenPortal, { className: "IncomingCallPortal", children: _jsx(UserSessionProvider, { value: userSession, children: pendingInvitation?.status === 'PENDING' &&
                !autoAcceptInvites &&
                !availabilityStatusNotAvailable ? (_jsxs(_Fragment, { children: [_jsx(CallNotification, { roomInvitation: pendingInvitation, onAnswer: answerCall, onReject: rejectCall, brandSettings: callConfig.brandSettings, showReservationCallDetailYn: !!callConfig.showReservationCallDetailYn }), SystemNotificationComponent && (_jsx(SystemNotificationComponent, { invitation: pendingInvitation }))] })) : null }) }));
};
//# sourceMappingURL=call_notification_listener.js.map